import React, { useCallback, useLayoutEffect, useRef, useState } from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

import { LoadingIndicator } from 'ui-components/components/loading-indicator';

import { useOnElementWidthChange } from '../../../../../hooks/use-on-element-width-change';
import { ShipmentDetailsGridLayout } from '../shipment-details-grid-layout';

import style from './resize-observer-layout.module.less';

const THREE_COLUMN_BREAKPOINT = 700;
const TWO_COLUMN_BREAKPOINT = 580;
const ONE_COLUMN_BREAKPOINT = 420;

const columnCountToClassNameMap = {
  1: style['one-column'],
  2: style['two-columns'],
  3: style['three-columns'],
  4: style['four-columns'],
};

export const LayoutContainer = ({ addressColumnContent, costSummaryColumnContent, datesColumnContent, assignmentColumnContent }) => {
  const [columnCount, setColumnCount] = useState(3);
  const [isContainerLoaded, setIsContainerLoaded] = useState(false);

  const containerRef = useRef(null);

  const updateLayout = useCallback((width) => {
    if (width <= ONE_COLUMN_BREAKPOINT) {
      setColumnCount(1);
    } else if (width <= TWO_COLUMN_BREAKPOINT) {
      setColumnCount(2);
    } else if (width <= THREE_COLUMN_BREAKPOINT) {
      setColumnCount(3);
    } else {
      setColumnCount(4);
    }
  }, []);

  useLayoutEffect(() => {
    if (containerRef.current) {
      updateLayout(containerRef.current?.offsetWidth);
      setIsContainerLoaded(true);
    }
  }, [updateLayout]);

  useOnElementWidthChange(containerRef, updateLayout);

  return (
    <div ref={containerRef}>
      {isContainerLoaded ? (
        <ShipmentDetailsGridLayout
          addressColumnContent={addressColumnContent}
          assignmentColumnContent={assignmentColumnContent}
          className={classnames(style['shipment-details-grid'], columnCountToClassNameMap[columnCount])}
          costSummaryColumnContent={costSummaryColumnContent}
          datesColumnContent={datesColumnContent}
          dividerClassName={columnCount < 3 ? style.divider : undefined}
        />
      ) : (
        <LoadingIndicator />
      )}
    </div>
  );
};

LayoutContainer.propTypes = {
  addressColumnContent: PropTypes.node.isRequired,
  costSummaryColumnContent: PropTypes.node.isRequired,
  datesColumnContent: PropTypes.node.isRequired,
  assignmentColumnContent: PropTypes.node.isRequired,
};
